import Vue from 'vue';

export default Vue.extend({
  name: 'colaboratorHoursMixin',
  data() {
    return {
      colaborator_hours: {
        lunes: { acceso: 'No Permitido' },
        martes: { acceso: 'No Permitido' },
        miercoles: { acceso: 'No Permitido' },
        jueves: { acceso: 'No Permitido' },
        viernes: { acceso: 'No Permitido' },
        sabado: { acceso: 'No Permitido' },
        domingo: { acceso: 'No Permitido' },
      },
    };
  },
  methods: {
    asign_colaborator_hours(data) {
      this.colaborator_hours.lunes.hora_entrada = data.hora_entrada_lunes;
      this.colaborator_hours.lunes.hora_salida = data.hora_salida_lunes;
      this.colaborator_hours.martes.hora_entrada = data.hora_entrada_martes;
      this.colaborator_hours.martes.hora_salida = data.hora_salida_martes;
      this.colaborator_hours.miercoles.hora_entrada = data.hora_entrada_miercoles;
      this.colaborator_hours.miercoles.hora_salida = data.hora_salida_miercoles;
      this.colaborator_hours.jueves.hora_entrada = data.hora_entrada_jueves;
      this.colaborator_hours.jueves.hora_salida = data.hora_salida_jueves;
      this.colaborator_hours.viernes.hora_entrada = data.hora_entrada_viernes;
      this.colaborator_hours.viernes.hora_salida = data.hora_salida_viernes;
      this.colaborator_hours.sabado.hora_entrada = data.hora_entrada_sabado;
      this.colaborator_hours.sabado.hora_salida = data.hora_salida_sabado;
      this.colaborator_hours.domingo.hora_entrada = data.hora_entrada_domingo;
      this.colaborator_hours.domingo.hora_salida = data.hora_salida_domingo;
      this.colaborator_hours.lunes.acceso = data.acceso_lunes;
      this.colaborator_hours.martes.acceso = data.acceso_martes;
      this.colaborator_hours.miercoles.acceso = data.acceso_miercoles;
      this.colaborator_hours.jueves.acceso = data.acceso_jueves;
      this.colaborator_hours.viernes.acceso = data.acceso_viernes;
      this.colaborator_hours.sabado.acceso = data.acceso_sabado;
      this.colaborator_hours.domingo.acceso = data.acceso_domingo;
    },
  },
});
